/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseDemeritEducationApiResponseCreateDemeritEducationReserveResult } from '../models/ApiResponseDemeritEducationApiResponseCreateDemeritEducationReserveResult';
import type { ApiResponseDemeritEducationApiResponseDemeritEducationEligibilityResponse } from '../models/ApiResponseDemeritEducationApiResponseDemeritEducationEligibilityResponse';
import type { ApiResponseDemeritEducationApiResponseListDemeritEducationBranchResponse } from '../models/ApiResponseDemeritEducationApiResponseListDemeritEducationBranchResponse';
import type { ApiResponseDemeritEducationApiResponseListDemeritEducationCenterResponse } from '../models/ApiResponseDemeritEducationApiResponseListDemeritEducationCenterResponse';
import type { ApiResponseDemeritEducationApiResponseListDemeritEducationReserveResponse } from '../models/ApiResponseDemeritEducationApiResponseListDemeritEducationReserveResponse';
import type { ApiResponseDemeritEducationApiResponseUpdateDemeritEducationReserveResult } from '../models/ApiResponseDemeritEducationApiResponseUpdateDemeritEducationReserveResult';
import type { ApiResponseDemeritEducationApiResponseVoid } from '../models/ApiResponseDemeritEducationApiResponseVoid';
import type { CreateDemeritEducationReserveRequest } from '../models/CreateDemeritEducationReserveRequest';
import type { DeleteDemeritEducationReserveRequest } from '../models/DeleteDemeritEducationReserveRequest';
import type { UpdateDemeritEducationReserveRequest } from '../models/UpdateDemeritEducationReserveRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DemeritEducationControllerService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 벌점감경교육 예약 조회
   * 기 등록된 예약정보를 조회합니다.
   * @returns ApiResponseDemeritEducationApiResponseListDemeritEducationReserveResponse OK
   * @throws ApiError
   */
  public getReserve({
    authorization,
  }: {
    authorization?: string,
  }): CancelablePromise<ApiResponseDemeritEducationApiResponseListDemeritEducationReserveResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/public-service/demerit-education/reserve',
      headers: {
        'Authorization': authorization,
      },
    });
  }
  /**
   * 벌점감경교육 예약 변경
   * 벌점감경교육 예약을 변경합니다.
   * @returns ApiResponseDemeritEducationApiResponseUpdateDemeritEducationReserveResult OK
   * @throws ApiError
   */
  public updateReserve({
    authorization,
    requestBody,
  }: {
    authorization?: string,
    requestBody: UpdateDemeritEducationReserveRequest,
  }): CancelablePromise<ApiResponseDemeritEducationApiResponseUpdateDemeritEducationReserveResult> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/public-service/demerit-education/reserve',
      headers: {
        'Authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 벌점감경교육 예약 등록
   * 벌점감경교육 예약을 등록합니다.
   * @returns ApiResponseDemeritEducationApiResponseCreateDemeritEducationReserveResult OK
   * @throws ApiError
   */
  public createReserve({
    authorization,
    requestBody,
  }: {
    authorization?: string,
    requestBody: CreateDemeritEducationReserveRequest,
  }): CancelablePromise<ApiResponseDemeritEducationApiResponseCreateDemeritEducationReserveResult> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/public-service/demerit-education/reserve',
      headers: {
        'Authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 벌점감경교육 취소
   * 벌점감경교육 예약을 취소합니다.
   * @returns ApiResponseDemeritEducationApiResponseVoid OK
   * @throws ApiError
   */
  public deleteReserve({
    authorization,
    requestBody,
  }: {
    authorization?: string,
    requestBody: DeleteDemeritEducationReserveRequest,
  }): CancelablePromise<ApiResponseDemeritEducationApiResponseVoid> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/public-service/demerit-education/reserve/deletion',
      headers: {
        'Authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 벌점감경교육 대상조회
   * 벌점감경교육 대상자여부를 조회합니다.
   * @returns ApiResponseDemeritEducationApiResponseDemeritEducationEligibilityResponse OK
   * @throws ApiError
   */
  public getEligibility({
    authorization,
  }: {
    authorization?: string,
  }): CancelablePromise<ApiResponseDemeritEducationApiResponseDemeritEducationEligibilityResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/public-service/demerit-education/eligibility',
      headers: {
        'Authorization': authorization,
      },
    });
  }
  /**
   * 벌점감경교육 교육장 조회
   * 벌점감경교육 교육장을 조회합니다.
   * @returns ApiResponseDemeritEducationApiResponseListDemeritEducationCenterResponse OK
   * @throws ApiError
   */
  public getCenters({
    branchCode,
    eduStartDate,
    eduEndDate,
  }: {
    /**
     * 지역코드
     */
    branchCode: string,
    /**
     * 시작일자 (YYYYMMDD)
     */
    eduStartDate: string,
    /**
     * 종료일자 (YYYYMMDD)
     */
    eduEndDate: string,
  }): CancelablePromise<ApiResponseDemeritEducationApiResponseListDemeritEducationCenterResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/public-service/demerit-education/center',
      query: {
        'branchCode': branchCode,
        'eduStartDate': eduStartDate,
        'eduEndDate': eduEndDate,
      },
    });
  }
  /**
   * 벌점감경교육 지역 조회
   * 벌점감경교육 교육장 지역을 조회합니다.
   * @returns ApiResponseDemeritEducationApiResponseListDemeritEducationBranchResponse OK
   * @throws ApiError
   */
  public getBranch(): CancelablePromise<ApiResponseDemeritEducationApiResponseListDemeritEducationBranchResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/public-service/demerit-education/branch',
    });
  }
}
